import { Image as ImageIcon, CornerUpLeft } from "lucide-react";

/**
 * The quoted-reply chip (spec §6). Shows the original author + a ≤120-char
 * excerpt + a media indicator. Clicking it jumps to / highlights the original.
 * A soft-deleted parent shows a "message deleted" placeholder with NO excerpt
 * (the server returns `{deleted:true}` and no body so a moderated parent never
 * leaks through a child's quote).
 *
 * Body excerpt is rendered as a plain text node (escaped/inert).
 */
export default function QuotedReplyChip({ preview, onJump, compact }) {
  if (!preview) return null;
  const cls = `vdsc-quote ${compact ? "compact" : ""}`;

  if (preview.deleted) {
    return (
      <div className={`${cls} deleted`}>
        <CornerUpLeft size={13} />
        <span className="vdsc-quote-deleted">message deleted</span>
      </div>
    );
  }

  const inner = (
    <>
      <span className="vdsc-quote-bar" aria-hidden="true" />
      <span className="vdsc-quote-content">
        <span className="vdsc-quote-author">{preview.author_name || "Unknown member"}</span>
        <span className="vdsc-quote-excerpt">
          {preview.has_media && (
            <ImageIcon size={12} className="vdsc-quote-mediaicon" />
          )}
          {preview.body_excerpt || (preview.has_media ? "Photo" : "")}
        </span>
      </span>
    </>
  );

  if (onJump) {
    return (
      <button
        type="button"
        className={`${cls} clickable`}
        onClick={() => onJump(preview.id)}
        title="Jump to the quoted message"
      >
        {inner}
      </button>
    );
  }
  return <div className={cls}>{inner}</div>;
}
